import { render, staticRenderFns } from "./AmRichText.vue?vue&type=template&id=29ff373f&"
import script from "./AmRichText.vue?vue&type=script&lang=js&"
export * from "./AmRichText.vue?vue&type=script&lang=js&"
import style0 from "./AmRichText.vue?vue&type=style&index=0&id=29ff373f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports